<template>
  <div class="modal-image-inspector">
    <button
      v-if="!disablePrev"
      class="modal-image-inspector__button modal-image-inspector__button--left"
      aria-label="See previous image"
      @click="options.displayIndex--">
      <oie-base-icon icon="chevron-left" size="l"></oie-base-icon>
    </button>
    <button
      v-if="!disableNext"
      class="modal-image-inspector__button modal-image-inspector__button--right"
      aria-label="See next image"
      @click="options.displayIndex++">
      <oie-base-icon icon="chevron-right" size="l"></oie-base-icon>
    </button>
    <img :src="`${options.images[options.displayIndex].url}`" alt="Machine image" class="modal-image-inspector__image">
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    disablePrev() {
      return this.options.displayIndex === 0
    },
    disableNext() {
      return this.options.displayIndex + 1 === this.options.images.length
    }
  }
}
</script>

<style lang="scss">
.modal-image-inspector__image {
  width: 100%;
  height: auto;
}

.modal-image-inspector__button {
  @include reset-button;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.modal-image-inspector__button--left {
  left: 0;
}

.modal-image-inspector__button--right {
  right: 0;
}
</style>
